import React from 'react';
import { Container } from 'react-bootstrap';
import Flipbook from '../components/Flipbook';

function ProjectNeznayka() {
  const imagePaths = [
    "/priklyucheniya-neznajki/20250927_105025.jpg",
    "/priklyucheniya-neznajki/20250927_105025(1).jpg",
    "/priklyucheniya-neznajki/20250927_105025(2).jpg",
    "/priklyucheniya-neznajki/20250927_105025(3).jpg",
    "/priklyucheniya-neznajki/20250927_105031.jpg",
    "/priklyucheniya-neznajki/20250927_105031(0).jpg",
    "/priklyucheniya-neznajki/20250927_105031(0)(1).jpg",
    "/priklyucheniya-neznajki/20250927_105031(0)(2).jpg",
    "/priklyucheniya-neznajki/20250927_105031(1).jpg",
    "/priklyucheniya-neznajki/20250927_105031(2).jpg",
    "/priklyucheniya-neznajki/20250927_105121.jpg",
    "/priklyucheniya-neznajki/20250927_105121(1).jpg",
    "/priklyucheniya-neznajki/20250927_105121(2).jpg",
    "/priklyucheniya-neznajki/20250927_105121(3).jpg",
    "/priklyucheniya-neznajki/20250927_105127.jpg",
    "/priklyucheniya-neznajki/20250927_105127(1).jpg",
    "/priklyucheniya-neznajki/20250927_105127(2).jpg",
    "/priklyucheniya-neznajki/20250927_105127(3).jpg",
    "/priklyucheniya-neznajki/20250927_105138.jpg",
    "/priklyucheniya-neznajki/20250927_105138(1).jpg",
    "/priklyucheniya-neznajki/20250927_105138(2).jpg",
    "/priklyucheniya-neznajki/20250927_105138(3).jpg",
    "/priklyucheniya-neznajki/20250927_105154.jpg",
    "/priklyucheniya-neznajki/20250927_105154(1).jpg",
    "/priklyucheniya-neznajki/20250927_105154(2).jpg",
    "/priklyucheniya-neznajki/20250927_105154(3).jpg",
    "/priklyucheniya-neznajki/20250927_105203.jpg",
    "/priklyucheniya-neznajki/20250927_105203(1).jpg",
    "/priklyucheniya-neznajki/20250927_105203(2).jpg",
    "/priklyucheniya-neznajki/20250927_105203(3).jpg",
    "/priklyucheniya-neznajki/20250927_105219.jpg",
    "/priklyucheniya-neznajki/20250927_105219(1).jpg",
    "/priklyucheniya-neznajki/20250927_105219(2).jpg",
    "/priklyucheniya-neznajki/20250927_105219(3).jpg",
    "/priklyucheniya-neznajki/20250927_105240.jpg",
    "/priklyucheniya-neznajki/20250927_105240(1).jpg",
    "/priklyucheniya-neznajki/20250927_105240(2).jpg",
    "/priklyucheniya-neznajki/20250927_105240(3).jpg",
    "/priklyucheniya-neznajki/20250927_105252.jpg",
    "/priklyucheniya-neznajki/20250927_105252(1).jpg",
    "/priklyucheniya-neznajki/20250927_105252(2).jpg",
    "/priklyucheniya-neznajki/20250927_105252(3).jpg",
    "/priklyucheniya-neznajki/20250927_105259.jpg",
    "/priklyucheniya-neznajki/20250927_105259(1).jpg",
    "/priklyucheniya-neznajki/20250927_105259(2).jpg",
    "/priklyucheniya-neznajki/20250927_105259(3).jpg",
    "/priklyucheniya-neznajki/20250927_105310.jpg",
    "/priklyucheniya-neznajki/20250927_105310(1).jpg",
    "/priklyucheniya-neznajki/20250927_105310(2).jpg",
    "/priklyucheniya-neznajki/20250927_105310(3).jpg",
    "/priklyucheniya-neznajki/20250927_105317.jpg",
    "/priklyucheniya-neznajki/20250927_105317(1).jpg",
    "/priklyucheniya-neznajki/20250927_105317(2).jpg",
    "/priklyucheniya-neznajki/20250927_105317(3).jpg",
    "/priklyucheniya-neznajki/20250927_105329.jpg",
    "/priklyucheniya-neznajki/20250927_105329(1).jpg",
    "/priklyucheniya-neznajki/20250927_105329(2).jpg",
    "/priklyucheniya-neznajki/20250927_105329(3).jpg",
    "/priklyucheniya-neznajki/20250927_105341.jpg",
    "/priklyucheniya-neznajki/20250927_105341(1).jpg",
    "/priklyucheniya-neznajki/20250927_105341(2).jpg",
    "/priklyucheniya-neznajki/20250927_105341(3).jpg"
  ].sort();

  return (
    <Container className="mt-4">
      <h1>Приключения Незнайки</h1>
      <p>Иллюстрации по мотивам знаменитой книги.</p>
      <p>Проект продолжается, следующие серии впереди в этом году!</p>
      <hr />
      <Flipbook images={imagePaths} />
    </Container>
  );
}

export default ProjectNeznayka;
